import * as React from 'react';

export interface InjectedProps {
  focusRef(element: any): any;
}

export interface FocusTrapProps {
  active: boolean;
  children(focusRef: (element: any) => any): JSX.Element;
}

const FOCUSABLE_SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';

export class FocusTrap extends React.Component<FocusTrapProps> {
  container: any;
  lastFocused: any;
  restoreFocusTo: any;

  setContainerRef = (element) => {
    this.container = element;
  };

  handleFocusIn = (event) => {
    if (!this.props.active) { return; }
    if (this.container.contains(event.target)) {
      this.lastFocused = event.target;
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const allFocusable = this.container.querySelectorAll(FOCUSABLE_SELECTOR);
    const first = this.container.querySelector(FOCUSABLE_SELECTOR);
    const last = allFocusable[allFocusable.length - 1];

    if (this.lastFocused === last) {
      first.focus();
    } else if (this.lastFocused === first) {
      last.focus();
    } else {
      first.focus();
    }
  };

  focusContainer = () => {
    if (this.container.querySelector(FOCUSABLE_SELECTOR)) {
      this.container.querySelector(FOCUSABLE_SELECTOR).focus();
    } else {
      this.container.focus();
    }
  };

  componentDidMount() {
    window.addEventListener('focusin', this.handleFocusIn);
    if (this.props.active) {
      this.focusContainer();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.active && !this.props.active) {
      this.restoreFocusTo = document.activeElement;
      this.focusContainer();
    } else if (this.props.active && !nextProps.active && this.restoreFocusTo) {
      this.restoreFocusTo.focus();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('focusin', this.handleFocusIn);
  }

  render() {
    return this.props.children(this.setContainerRef);
  }
}

export default FocusTrap;
